module.exports = __webpack_public_path__ + "static/media/flashlight.397a61a1.svg";